import { USER_ROLE_TYPE } from "src/constant";

/** Role được xem đủ 3 tab nhân viên (Tất cả / Kho-KT / KD) + thao tác thêm/sửa/xóa (trừ khi bị chặn ở từng màn). */
export const EMPLOYEE_FULL_MODULE_ROLE_CODES = [
  USER_ROLE_TYPE.SUPER_ADMIN,
  USER_ROLE_TYPE.ADMIN_ACCOUNTANT,
  USER_ROLE_TYPE.ADMIN_FACTORY,
  USER_ROLE_TYPE.ADMIN_WAREHOUSE,
  USER_ROLE_TYPE.MANAGER_WAREHOUSE,
];

export const hasFullEmployeeTabs = (roleCode) => EMPLOYEE_FULL_MODULE_ROLE_CODES.includes(roleCode);

export const canMutateEmployeeRows = (roleCode) => EMPLOYEE_FULL_MODULE_ROLE_CODES.includes(roleCode);
